import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Multiple scroll methods to ensure it works
    const scrollToTop = () => {
      // Method 1: Standard window scroll
      window.scrollTo(0, 0);
      
      // Method 2: Document element scroll
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      
      // Method 3: Body scroll
      if (document.body) {
        document.body.scrollTop = 0;
      }

      // Method 4: Scroll specific container if exists
      const scrollableContent = document.getElementById('scrollable-content');
      if (scrollableContent) {
        scrollableContent.scrollTop = 0;
      }
    };

    // Add a small delay to ensure DOM is ready
    const timeoutId = setTimeout(scrollToTop, 0);

    // Cleanup timeout
    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};

export default ScrollToTop;